"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
function useOpen(initial = false) {
    const open = (0, vue_1.ref)(initial);
    const onToggle = function () {
        open.value = !open.value;
    };
    const onOpen = function () {
        open.value = true;
    };
    const onClose = function () {
        open.value = false;
    };
    return (0, vue_1.reactive)({ open, onClose, onOpen, onToggle });
}
exports.default = useOpen;
